import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ASSET = (p) => (p?.startsWith("http") ? p : `${BACKEND_URL}${p}`);

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Global JSON cache, populated by every successful GET and by the
// prerendered <script>window.__INITIAL_DATA__</script> block. useFetch
// reads from this synchronously so hydrated first-render matches the
// prerendered HTML (no hydration mismatch on data-driven components).
export function _ensureCache() {
  if (typeof window === "undefined") return {};
  if (!window.__INITIAL_DATA__) window.__INITIAL_DATA__ = {};
  return window.__INITIAL_DATA__;
}

export function getCached(path) {
  if (typeof window === "undefined") return undefined;
  return window.__INITIAL_DATA__ ? window.__INITIAL_DATA__[path] : undefined;
}

export function setCached(path, data) {
  if (typeof window === "undefined") return;
  _ensureCache()[path] = data;
}

export async function fetchJson(path) {
  const { data } = await api.get(path);
  setCached(path, data);
  return data;
}
